const joinArray = (arr) => {
    return arr.map(function (item: any) {
        return item;
    }).join(";");
};

export default joinArray;
